/**
 * @module actions/priceModelConclict
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Getting pricelist conflicts by wpId
 * @return {Promise} Axios promise
 */
export function getPriceModelConflicts (wpId) {
  let url = API_URL + '/PriceModelConflict/' + wpId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting pricelist conflicts for customer
 * @return {Promise} Axios promise
 */
export function getPriceModelConflictsCustomer (customerId) {
  let url = API_URL + '/PriceModelConflict/Get/' + customerId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description update pricelist conflict
 * @return {Promise} Axios promise
 */
export function updatePriceModelConflicts (data) {
  let url = API_URL + '/PriceModelConflict/Post/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/priceModelConflict.js